import ManagerAbsence from "../ManagerAbsence";
import MyAbsence from "../MyAbsence";
import RhAbsence from "../RhAbsence";

export const TABS_LEAVE = {
    absences: "Mes absences",
    teamCalendar: "Mon équipe",
    societyCalendar: "Entreprise",
    // soldeAjustement: "Ajustement des soldes",
};

export const TABS_LEAVE_ARRAY = [
    TABS_LEAVE.absences,
    TABS_LEAVE.teamCalendar,
    TABS_LEAVE.societyCalendar,
];

export const _renderTab = (activeTab, isRH, isManager, holiday_list) => {
    switch (activeTab) {
        case TABS_LEAVE.absences:
            return (
                <MyAbsence
                    holidayList={holiday_list}
                    isRH={isRH}
                    subHeader={0}
                />
            );
        case TABS_LEAVE.teamCalendar:
            return (
                <ManagerAbsence
                    isManager={true}
                    subHeader={1}
                    holidayList={holiday_list}
                />
            );
        case TABS_LEAVE.societyCalendar:
            return (
                <RhAbsence
                    isRH={isRH}
                    isManager={isManager}
                    subHeader={2}
                    holidayList={holiday_list}
                />
            );
        // case TABS_LEAVE.soldeAjustement:
        //     return <SoldeAjustement isRH={isRH} subHeader={3} />;
        default:
            break;
    }
};
